import { SEARCH_MATCH_HIGHLIGHT_ATTRIBUTE } from '../documentation-article.const'

export function clearSearchMatchHighlights(root: ParentNode) {
  const marks = root.querySelectorAll(`[${SEARCH_MATCH_HIGHLIGHT_ATTRIBUTE}]`)

  marks.forEach((mark) => {
    const parent = mark.parentNode
    if (!parent) {
      return
    }

    while (mark.firstChild) {
      parent.insertBefore(mark.firstChild, mark)
    }

    parent.removeChild(mark)
    parent.normalize()
  })
}
